import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import utils from "../../components/toastify/toastify";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
//locall
import "./CommentDetails.css";

const CommentDetails = (props) => {
  const [
    confirm_comment_error,
    confirm_comment_loading,
    confirm_comment_data,
    confirm_comment_function,
  ] = useRequest({
    method: "post",
    url: "/confirm_comment",
    body: {
      comment_id: props.match.params.id,
    },
    isFunction: true,
  });

  const [
    get_comments_error,
    get_comments_loading,
    get_comments_data,
    get_comments_function,
  ] = useRequest({
    method: "post",
    url: "/get_comment_details",
    body: {
      comment_id: props.match.params.id,
    },
  });

  return !get_comments_data ? null : (
    <>
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  {/* <li class="breadcrumb-item active">افزودن محصول جدید</li> */}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <section className="card card-body">
          <div class="row" style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ marginBottom: "10px" }}></div>
            <div style={{ marginBottom: "10px" }}>
              متن کامنت : {get_comments_data.data.text}
            </div>
            <button
              type="button"
              class="btn btn-success round mr-1 mb-1 btn-sm"
              style={{ width: "fit-content" }}
              onClick={() =>
                confirm_comment_function()
                  .then(() =>
                    utils.showAlert("کامنت با موفقیت تایید شد", "success")
                  )
                  .catch(() =>
                    utils.showAlert(
                      "مشکلی در انجام عملیات به وجود آمد",
                      "error"
                    )
                  )
              }
            >
              تایید کامنت
            </button>
          </div>
        </section>
      </div>
      {/* <!-- BEGIN: Content--> */}
    </>
  );
};

export { CommentDetails };
